import { render, staticRenderFns } from "./processes.vue?vue&type=template&id=1c1b2b4e&scoped=true"
import script from "./processes.vue?vue&type=script&lang=js"
export * from "./processes.vue?vue&type=script&lang=js"
import style0 from "./processes.vue?vue&type=style&index=0&id=1c1b2b4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1b2b4e",
  null
  
)

export default component.exports